import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { HostGeneralInfoService } from './host-general-info.service';
import { ImsService } from '../../ims.service';
import { ToasterService } from 'src/app/toaster.service';
import { Toaster, ToasterType } from 'src/app/shared/types';
import { resolveDomainValidationErrorMessage } from 'src/app/shared/domain-validation/domain-validation-messages';


const IMAGES = {
    vehicle: '/assets/svgImages/vehicle.svg',
  };

const HOST_PROFILE_TYPE = 'host';

@Component({
    selector: 'app-host-general-info',
    templateUrl: './host-general-info.component.html',
    styleUrls: ['./host-general-info.component.css'],
    providers: [DatePipe],
})
export class HostGeneralInfoComponent implements OnInit, OnChanges {

    @Input() data: any;
    public info: any = {};
    public vehicleDetails: any;
    public referralSummary: any = {};
    public hoprMetrics: any = null;
    public showEmailDialog = false;
    public showDeleteEmailDialog = false;
    public newEmail = '';
    public updatingEmail = false;
    public deletingEmail = false;
    public errorMsg = '';
    public domainType = '';
    public domainTypeLookupLoading = false;
    public readonly domainTypeOptions = ['corporate', 'non_corporate'];
    public deleteErrorMsg = '';
    public showNameDialog = false;
    public newName = '';
    public updatingName = false;
    public nameErrorMsg = '';
    constructor(
        public dialog: MatDialog,
        public hostGeneralInfoService: HostGeneralInfoService,
        private imsService: ImsService,
        private toasterService: ToasterService,
        private datePipe: DatePipe,
    ) { }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.data && changes.data.currentValue) {
            this.data = changes.data.currentValue;
            if (this.data.dataFetched) {
                this.getHostVehicleDetail(() => {
                    this.constructCard();
                });
            } else {
                this.blankCard();
            }
        } else {
            this.emptyCard();
        }
    }

    ngOnInit() { }

    blankCard() {
        this.info = {
            header: 'General Info',
            data: [],
            dataFetched: false
        };
    }

    emptyCard() {
        this.info = {
            header: 'General Info',
            dataFetched: false,
            data: null
        };
    }

    constructCard() {
        if (this.data && this.data.dataFetched) {
            const hostProfileData = this.data.profiles.filter(profile => profile.type === HOST_PROFILE_TYPE)[0];
            if (!hostProfileData) {
                this.blankCard();
                return;
            }
            const selectedVehicle = this.vehicleDetails.selectedVehicle || this.vehicleDetails.vehicleData;
            const vehicleNumber = selectedVehicle ? (selectedVehicle.number || 'N/A') : 'N/A';
            const vehicleName = selectedVehicle && selectedVehicle.info
                ? ((selectedVehicle.info.manufacturer || '') + ' ' + (selectedVehicle.info.model || '')).trim() || 'N/A'
                : 'N/A';
            const vehicleTypeDisplayName = this.vehicleDetails.vehicleTypeDisplayName || 'N/A';
            this.info = {
                header: 'General Info',
                dataFetched: true,
                data: [
                    {
                        header: 'Name',
                        value: this.data.name,
                        className: 'id-icon',
                        svgIcon: true,
                        actionMenuItems: [
                            { label: 'Edit Name', event: 'Edit Name' }
                        ]
                    },
                    { header: 'Gender', value: this.data.gender, className: 'id-icon', svgIcon: true },
                    {
                        header: 'Email',
                        value: hostProfileData.email,
                        className: 'email-id-icon',
                        svgIcon: true,
                        actionMenuItems: this.getEmailActionMenuItems(hostProfileData.email)
                    },
                    { header: 'Vehicle Number', value: vehicleNumber, svgIcon: true, className: 'email-id-icon' },
                    { header: 'Vehicle Name', value: vehicleName, svgIcon: true, className: 'email-id-icon' },
                    { header: 'Vehicle Type', value: vehicleTypeDisplayName, svgIcon: true, className: 'email-id-icon' },
                    { header: 'LTR', value: this.getLtrValue(), svgIcon: true, className: 'id-icon' },
                    ...(this.referralSummary.myReferralCode ? [{ header: 'My Referral Code', value: this.referralSummary.myReferralCode, svgIcon: true, className: 'referral-code-icon' }] : []),
                    ...(this.referralSummary.referredBy && this.referralSummary.referredBy.name ? [{ header: 'Referred By', value: this.referralSummary.referredBy.mobile ? `${this.referralSummary.referredBy.name} (${this.referralSummary.referredBy.mobile})` : this.referralSummary.referredBy.name, svgIcon: true, className: 'referral-code-icon', ...(this.referralSummary.referredBy.role && this.referralSummary.referredBy.mobile ? { redirectLink: `/${this.referralSummary.referredBy.role.toLowerCase()}/${this.referralSummary.referredBy.mobile}` } : {}) }] : []),
                    ...(this.referralSummary.referredBy && this.referralSummary.referredBy.code ? [{ header: 'Referred By Code', value: this.referralSummary.referredBy.code, svgIcon: true, className: 'referral-code-icon' }] : []),
                    ...(this.referralSummary.referredAt ? [{ header: 'Referred At', value: this.formatDate(this.referralSummary.referredAt), svgIcon: true, className: 'referral-code-icon' }] : []),
                    ...(this.referralSummary.referredRewardAchievedAt ? [{ header: 'Referral Reward At', value: this.formatDate(this.referralSummary.referredRewardAchievedAt), svgIcon: true, className: 'referral-code-icon' }] : []),
                ]
            };
        }
    }

    accessCookie(cookieName) {
        const name = cookieName + '=';
        const allCookieArray = document.cookie.split(';');
        for (let i = 0; i < allCookieArray.length; i++) {
            const temp = allCookieArray[i].trim();
            if (temp.indexOf(name) === 0) {
                return temp.substring(name.length, temp.length);
            }
        }
        return '';
    }

    getHostVehicleDetail(callback: () => void) {
        const hostProfile = this.data.profiles.filter(profile => profile.type === HOST_PROFILE_TYPE)[0];
        if (!hostProfile) {
            this.blankCard();
            return;
        }
        const hostProfileId = hostProfile.id;
        let completedCount = 0;
        const totalCalls = 3;
        const checkComplete = () => {
            completedCount++;
            if (completedCount === totalCalls) {
                callback();
            }
        };

        this.hostGeneralInfoService.getHostVehicleDetails(hostProfileId).subscribe(
            (result: { hosts: any[] }) => {
                if (result && result.hosts.length > 0) {
                    this.vehicleDetails = result.hosts[0];
                    this.vehicleDetails.dataFetched = true;
                } else {
                    this.vehicleDetails = { dataFetched: false };
                }
                checkComplete();
            },
            error => {
                console.error('Error fetching host vehicle details:', error);
                this.vehicleDetails = { dataFetched: false };
                checkComplete();
            }
        );

        this.hostGeneralInfoService.getReferralSummary(hostProfileId).subscribe(
            (result: any) => {
                this.referralSummary = result || {};
                checkComplete();
            },
            error => {
                console.error('Error fetching referral summary:', error);
                this.referralSummary = {};
                checkComplete();
            }
        );

        this.hostGeneralInfoService.getHoprMetrics(hostProfileId).subscribe(
            (result: any) => {
                this.hoprMetrics = result || null;
                checkComplete();
            },
            error => {
                console.error('Error fetching HOPR metrics:', error);
                this.hoprMetrics = null;
                checkComplete();
            }
        );
    }

    formatDate(dateStr: string): string {
        if (!dateStr) { return 'N/A'; }
        return this.datePipe.transform(dateStr, 'mediumDate') || 'N/A';
    }

    getLtrValue(): string {
        const metrics = this.hoprMetrics && this.hoprMetrics.data
            ? this.hoprMetrics.data
            : this.hoprMetrics;
        const netRides = metrics
            && metrics.lifeTimeRideBehaviour
            && metrics.lifeTimeRideBehaviour.netRides;
        if (typeof netRides === 'number') {
            return String(netRides);
        }
        return 'N/A';
    }

    getEmailActionMenuItems(email: string) {
        const menuItems = [{ label: 'Edit Email', event: 'Edit Email' }];
        if (email) {
            menuItems.push({ label: 'Delete Email', event: 'Delete Email' });
        }
        return menuItems;
    }

    eventTriggered(value: string) {
        if (value === 'Edit Email') {
            this.errorMsg = '';
            this.newEmail = '';
            this.resetDomainTypeSelection();
            this.showEmailDialog = true;
        } else if (value === 'Delete Email') {
            this.deleteErrorMsg = '';
            this.showDeleteEmailDialog = true;
        } else if (value === 'Edit Name') {
            this.nameErrorMsg = '';
            this.newName = '';
            this.showNameDialog = true;
        }
    }

    closeEmailDialog() {
        if (this.updatingEmail) {
            return;
        }
        this.showEmailDialog = false;
        this.newEmail = '';
        this.resetDomainTypeSelection();
        this.errorMsg = '';
    }

    resetDomainTypeSelection() {
        this.domainType = '';
        this.domainTypeLookupLoading = false;
    }

    canLookupEmail(): boolean {
        const trimmedEmail = this.newEmail ? this.newEmail.trim() : '';
        return trimmedEmail.indexOf('@') > 0;
    }

    lookupEmailDomain() {
        const trimmedEmail = this.newEmail ? this.newEmail.trim() : '';
        if (!trimmedEmail || trimmedEmail.indexOf('@') <= 0) {
            this.resetDomainTypeSelection();
            return;
        }

        this.domainTypeLookupLoading = true;
        this.imsService.lookupEmailDomain(trimmedEmail).subscribe({
            next: (response: any) => {
                this.domainTypeLookupLoading = false;
                if (response && response.exists && response.domainType) {
                    this.domainType = response.domainType;
                } else {
                    this.domainType = '';
                }
            },
            error: () => {
                this.domainTypeLookupLoading = false;
                this.domainType = '';
            }
        });
    }

    submitEmail() {
        if (!this.data || !this.data.profiles) {
            return;
        }
        const hostProfile = this.data.profiles.find(profile => profile.type === HOST_PROFILE_TYPE);
        const normalizedEmail = this.newEmail ? this.newEmail.trim() : '';
        if (!hostProfile || !normalizedEmail) {
            this.errorMsg = 'Please enter a valid email.';
            return;
        }
        if (!this.domainType) {
            this.errorMsg = 'Please select a domain type.';
            return;
        }

        this.updatingEmail = true;
        this.errorMsg = '';
        this.imsService.updateUserEmail(this.data.id, normalizedEmail, [HOST_PROFILE_TYPE], this.domainType).subscribe({
            next: () => {
                hostProfile.email = normalizedEmail;
                this.constructCard();
                this.showEmailDialog = false;
                this.newEmail = '';
                this.updatingEmail = false;
                this.toasterService.showToaster(new Toaster({
                    type: ToasterType.SUCCESS,
                    message: 'Email updated successfully.'
                }));
            },
            error: (err) => {
                this.updatingEmail = false;
                this.errorMsg = resolveDomainValidationErrorMessage(err);
            }
        });
    }

    closeDeleteEmailDialog() {
        if (this.deletingEmail) {
            return;
        }
        this.showDeleteEmailDialog = false;
        this.deleteErrorMsg = '';
    }

    deleteEmail() {
        if (!this.data || !this.data.id) {
            return;
        }
        this.deletingEmail = true;
        this.deleteErrorMsg = '';
        this.imsService.deleteUserEmail(this.data.id).subscribe({
            next: () => {
                this.showDeleteEmailDialog = false;
                this.deletingEmail = false;
                this.toasterService.showToaster(new Toaster({
                    type: ToasterType.SUCCESS,
                    message: 'Email deleted successfully.'
                }));
                window.location.reload();
            },
            error: (err) => {
                this.deletingEmail = false;
                this.deleteErrorMsg = (err && err.error && err.error.metadata && err.error.metadata.error &&
                    err.error.metadata.error.displayMessage) || 'Failed to delete email';
            }
        });
    }

    closeNameDialog() {
        if (this.updatingName) {
            return;
        }
        this.showNameDialog = false;
        this.newName = '';
        this.nameErrorMsg = '';
    }

    submitName() {
        if (!this.data) {
            return;
        }
        if (!this.newName || !this.newName.trim()) {
            this.nameErrorMsg = 'Please enter a valid name.';
            return;
        }

        this.updatingName = true;
        this.nameErrorMsg = '';
        this.imsService.updateUserName(this.data.id, this.newName.trim()).subscribe({
            next: () => {
                this.data.name = this.newName.trim();
                this.constructCard();
                this.showNameDialog = false;
                this.newName = '';
                this.updatingName = false;
                this.toasterService.showToaster(new Toaster({
                    type: ToasterType.SUCCESS,
                    message: 'Name updated successfully.'
                }));
            },
            error: (err) => {
                this.updatingName = false;
                this.nameErrorMsg = (err && err.error && err.error.metadata && err.error.metadata.error &&
                    err.error.metadata.error.displayMessage) || 'Failed to update name';
            }
        });
    }
}
